export class Media {
    _id: string;
    name: string;
    type: string;
    project_id: string;
    uri: string;
    language: string;

    constructor(data) {
        this._id = data._id;
        this.name = data.name;
        this.type = data.type;
        this.project_id = data.project_id;
        this.uri = data.uri;
        this.language = data.language;
    }
}
